import { useEffect, useState } from 'react'

import { useAuth } from '@/lib/auth'
import { useFeedback } from '@/components/FeedbackProvider'
import { AboutScreen } from '@/screens/AboutScreen'

export function AboutScreenContainer() {
  const { user } = useAuth()
  const {
    conversation,
    messages,
    lastReadAt,
    isLoading,
    isSending,
    error,
    sendMessage,
    markAllRead,
  } = useFeedback()

  // Snapshot the read watermark from when this screen opened, so replies that
  // were unread on arrival (and any that stream in while viewing) stay
  // highlighted as "new" even after markAllRead clears the global badge.
  const [newSince, setNewSince] = useState<string | null | undefined>(undefined)

  // Being on this screen means the conversation is in view — clear the unread
  // watermark whenever messages change (polling only runs while the tab is
  // visible, so updates here imply the user can see them).
  useEffect(() => {
    if (messages.length > 0) {
      setNewSince((prev) => (prev === undefined ? lastReadAt : prev))
      markAllRead()
    }
  }, [messages, lastReadAt, markAllRead])

  if (!user) {
    return (
      <div className="bg-slate-50 flex items-center justify-center">
        <p className="text-slate-600">Please log in to send feedback.</p>
      </div>
    )
  }

  return (
    <AboutScreen
      conversation={conversation}
      messages={messages}
      newSince={newSince}
      isLoading={isLoading}
      isSending={isSending}
      error={error}
      onSendMessage={sendMessage}
    />
  )
}
